import {
    useEffect,
    useState,
} from 'react';

import {Autocomplete,} from '@mantine/core';

import {useCustomers} from '../hooks/useCustomers.ts';
import {Customer} from '../types';
import {FieldProps} from 'formik';
import {useAuth} from "../../../hooks/useAuth.ts";

export const CustomersAutocomplete = ({
                                          field: {
                                              name,
                                              value: fieldValue,
                                          },
                                          form: {setFieldValue},
                                          ...rest
                                      }: FieldProps) => {

    const {user} = useAuth()

    if (!user) {
        throw new Error('user is required parameter')
    }

    const {items: records, fetchRecords} = useCustomers();

    const [value, setValue] = useState('');
    const [disabled, setDisabled] = useState(false);

    useEffect(() => {
        fetchRecords();
    }, []);

    const data = records.map((record: Customer) => {
        return {
            ...record,
            label: record.name || record.id,
            // FNP-1487: the id, never the name. Names are not unique — two
            // customers share "Ean Fisher" — and Mantine 8 throws on duplicate
            // option values, which took down the whole route.
            value: record.id,
        };
    });

    useEffect(() => {
        if (records.length === 0) {
            setDisabled(true);
        } else {
            setDisabled(false);
        }

        const found = records.find((item: Customer) => item.id === fieldValue);
        if (typeof found !== 'undefined' && Object.prototype.hasOwnProperty.call(found, 'name')) {
            setValue(found.name as string);
        }
    }, [records.length]);

    const handleChange = (value: string) => {
        if (!Array.isArray(data)) {
            throw new Error('Data is expected to be an array');
        }
        // FNP-1487: match on id. Matching on name returned the FIRST record of
        // any duplicate pair, so picking the second "Ean Fisher" silently stored
        // the wrong customer's id.
        const found = data.find((item) => item.id === value);

        if (typeof found !== 'undefined') {
            setFieldValue(name, found.id);
            setValue(found.name || found.id);
            return;
        }

        setValue(value);
    };

    return (
        <Autocomplete
            name={name}
            value={value}
            onChange={handleChange}
            data={data}
            disabled={disabled}
            placeholder='Select Customer'
            {...rest}
        />
    );
};
